import { FIELD_ATTACHMENT_IDS_KEY } from "PFApp/constants/activity_form/activity_form_field_keys";
import { Sections } from "PFApp/types/activity_form/activity_form_schema";
import { useMemo } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useActivityFormStore } from "../activity_form_store/use_activity_form_store";
import {
  AttachmentsFormSection,
  AttributesFormSection,
  AvailabilityFormSection,
  BasicInformationFormSection,
  ConversationFormSection,
  MatchAttributesFormSection,
  PrivacyFormSection,
  RoleTypeFormSection,
  ShowInterestQuestionsFormSection,
  SkillsFrameworksFormSection
} from "../parts/form_sections";

export const useVisibleSections = () => {
  const { t } = useTranslation("activities", { keyPrefix: "form.sections" });
  const { t: tActivities } = useTranslation("activities");
  const attachmentsCount = useWatch({ name: FIELD_ATTACHMENT_IDS_KEY }).length;

  const formSchema = useActivityFormStore((state) => state.formSchema);
  const template = useActivityFormStore((state) => state.template);
  const templateName = tActivities(`templates.${template.key}`);
  const availabilityTitle = template.schema.properties?.availability?.title;

  return useMemo(
    () =>
      [
        {
          id: Sections.Subtemplate,
          component: RoleTypeFormSection,
          title: t("subtemplate.sectionTitle", { templateName })
        },
        {
          id: Sections.BasicInformation,
          component: BasicInformationFormSection,
          title: t("basicInformation.title")
        },
        {
          id: Sections.SkillsFrameworks,
          component: SkillsFrameworksFormSection,
          title: t("skillsFrameworks.title")
        },
        {
          id: Sections.MatchAttributes,
          component: MatchAttributesFormSection,
          title: t("matchAttributes.title")
        },
        {
          id: Sections.Availability,
          component: AvailabilityFormSection,
          title: availabilityTitle || t("availability.title")
        },
        {
          id: Sections.Attributes,
          component: AttributesFormSection,
          title: t("attributes.title")
        },
        {
          id: Sections.Attachments,
          component: AttachmentsFormSection,
          title: t("attachments.title"),
          count: attachmentsCount
        },
        {
          id: Sections.Privacy,
          component: PrivacyFormSection,
          title: t("privacy.title")
        },
        {
          id: Sections.Conversation,
          component: ConversationFormSection,
          title: t("conversation.title")
        },
        {
          id: Sections.ShowInterestQuestions,
          component: ShowInterestQuestionsFormSection,
          title: t("showInterestQuestions.title")
        }
      ].filter(({ id }) => formSchema![id]),
    [formSchema, t, availabilityTitle, templateName, attachmentsCount]
  );
};
